'use strict';

var _ = require('lodash');
var ClassIndexMappingService = function ClassIndexMappingService(configurationService) {
  function getClassIndexMapping(legs, fcrTag) {
    if (legsWithSameClassConfig(legs, fcrTag)) {
      return configurationService.getClassIndexMapping(legs[0], fcrTag);
    } else {
      return configurationService.getAllClassesIndexMapping(fcrTag);
    }
  }
  function legsWithSameClassConfig(legs, fcrTag) {
    return _.chain(legs).map(function (leg) {
      return buildClassConfigId(configurationService.getClassIndexMapping(leg, fcrTag));
    }).uniq().value().length === 1;
  }
  function buildClassConfigId(classIndexMapping) {
    return _.chain(classIndexMapping).map(function (classIndex, className) {
      return className + classIndex;
    }).sortBy().reduce(function (result, value) {
      return result + value;
    }, '').value();
  }
  return {
    getClassIndexMapping: getClassIndexMapping
  };
};
ClassIndexMappingService.$inject = ['ConfigurationService'];
module.exports = ClassIndexMappingService;